let max_step = 0;

export default class ProgressStepWizard {
  constructor(id, formElement, editMode) {
    this.form = formElement;
    this.wizardPlugin = formElement.getPlugin("wizard");
    this.element = document.getElementById(id);
    this.steps = typeof this.wizardPlugin !== "undefined" ? this.wizardPlugin.numSteps : 0;
    this.max_step = editMode ? this.wizardPlugin.numSteps - 1 : max_step;
    this.step_now = 0;
    this.editMode = editMode;
    this.create();
  }

  create() {
    const _elm = this.element;
    const _steps = this.steps;
    const _bar = `<div class="progress">
                     <div class="progress-bar" role="progressbar" aria-label="Register Step" style="width:0%" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                  </div>`;
    _elm.innerHTML = _bar;
    _elm.classList.add("prograss-step-wizard");
    for (let index = 0; index < _steps; index++) {
      const _point = document.createElement("span");
      _point.setAttribute("data-progress-point", index);
      _point.classList.add("point-item", "rounded-pill");
      if (index == 0) {
        _point.classList.add("active");
      }
      _point.innerHTML = index + 1;
      _point.style.left = index * (100 / (_steps - 1)) + "%";
      _point.addEventListener("click", (e) => {
        this.active(index);
      });
      _elm.appendChild(_point);
    }
  }

  active(index) {
    const _btn_step = index;
    if (_btn_step <= this.max_step) {
      this.goToStep(_btn_step);
      if (typeof this.wizardPlugin !== "undefined") {
        this.wizardPlugin.goToStep(_btn_step);
        this.step_now = _btn_step;
      }
      this.editMode ? this.form.validate() : null;
    }
  }

  goToStep(step) {
    const _steps = this.steps;
    const _bar = this.element.querySelector(".progress-bar");
    const _points = this.element.querySelectorAll("[data-progress-point]");
    _points.forEach((btn) => {
      if (btn.dataset.progressPoint <= step) {
        let _percent = btn.dataset.progressPoint * (100 / (_steps - 1));
        btn.classList.add("active");
        _bar.ariaValueNow = _percent;
        _bar.style.width = _percent + "%";
        this.max_step = this.max_step <= step ? step : this.max_step;
        this.step_now = step;
      } else {
        btn.classList.remove("active");
      }
    });
  }
}
